import l10n from '../l10n/localization';

export default {
    invoiceNumber: {
        presence: {
            message: l10n.validation.required,
        },
    },
    company: {
        presence: {
            message: l10n.validation.required,
        },
    },
    totalCost: {
        presence: {
            message: l10n.validation.required,
        },
    },
};



// WEBPACK FOOTER //
// ./src/validation/cost.js